import { useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';

import { error } from '../actions/general';
import { getRoute, payNowHandoff } from '../actions/sessions';
import { navigateTo } from '../lib/utils/navigation';

export default function usePayNowHandoff({
  unavailableMessage,
  failureMessage,
  onOutcome,
}) {
  const dispatch = useDispatch();
  const inFlight = useRef(false);
  const [submitting, setSubmitting] = useState(false);

  const startHandoff = async () => {
    if (inFlight.current) return;
    inFlight.current = true;
    setSubmitting(true);

    try {
      const response = await dispatch(payNowHandoff());
      onOutcome?.('handoff', { checkoutUrl: response.checkout_url });
      navigateTo(response.checkout_url);
    } catch (handoffError) {
      const status = handoffError.response && handoffError.response.status;
      onOutcome?.(status === 409 || status === 422 ? 'rejected' : 'failed', {
        status,
        reasonCode: handoffError.response?.data?.reason_code,
      });
      if (status === 401) {
        dispatch(error(handoffError));
      } else if (status === 409 || status === 422) {
        try {
          await dispatch(getRoute());
        } catch (routeError) {
          const routeResponse = routeError.response;
          const data = routeResponse && routeResponse.data;
          if (
            routeResponse &&
            routeResponse.status === 409 &&
            data &&
            typeof data.checkout_url === 'string' &&
            data.checkout_url
          ) {
            navigateTo(data.checkout_url);
          } else {
            dispatch(error(routeError));
          }
        }
        toast.error(unavailableMessage);
      } else {
        toast.error(failureMessage);
      }
      inFlight.current = false;
      setSubmitting(false);
    }
  };

  return { startHandoff, submitting };
}
